export var BLOCK_CALENDAR_FETCH_START_ACTION_TYPE = 'block_calendar/fetch_start';
export var BLOCK_CALENDAR_FETCH_SUCCESS_ACTION_TYPE = 'block_calendar/fetch_success';
export var BLOCK_CALENDAR_GET_START_ACTION_TYPE = 'block_calendar/get_start';
export var BLOCK_CALENDAR_GET_SUCCESS_ACTION_TYPE = 'block_calendar/get_success';
export var BLOCK_CALENDAR_SAVE_START_ACTION_TYPE = 'block_calendar/save_start';
export var BLOCK_CALENDAR_SAVE_SUCCESS_ACTION_TYPE = 'block_calendar/save_success';
export var BLOCK_CALENDAR_DELETE_START_ACTION_TYPE = 'block_calendar/delete_start';
export var BLOCK_CALENDAR_DELETE_SUCCESS_ACTION_TYPE = 'block_calendar/delete_success';
export var BLOCK_CALENDAR_COUNT_RECURRENT_START_ACTION_TYPE = 'block_calendar/count_recurrent_start';
export var BLOCK_CALENDAR_COUNT_RECURRENT_SUCCESS_ACTION_TYPE = 'block_calendar/count_recurrent_success';
export var BLOCK_CALENDAR_RESET_ACTION_TYPE = 'block_calendar/reset';
export var BLOCK_CALENDAR_ERROR_ACTION_TYPE = 'block_calendar/error';
export var BLOCK_CALENDAR_CLEAR_ALERTS_ACTION_TYPE = "block_calendar/clear_alerts";
export var BLOCK_CALENDAR_FETCH_ALERTS_START_ACTION_TYPE = "block_calendar/fetch_alerts_start";
export var BLOCK_CALENDAR_FETCH_ALERTS_SUCCESS_ACTION_TYPE = "block_calendar/fetch_alerts_success";
export var BLOCK_CALENDAR_LOCAL_DELETE_ACTION_TYPE = 'block_calendar/local_delete';
export var BLOCK_CALENDAR_LOCAL_UPDATE_ACTION_TYPE = 'block_calendar/local_update';
export var BLOCK_CALENDAR_LOCAL_ADD_ACTION_TYPE = 'block_calendar/local_add';
